import { capitalize } from './text';

export const formatSeatDescription = (obj, t) => {
  const section = obj.section
    ? t('seatDescription.section', { section: capitalize(obj.section) })
    : null;
  const table = obj.table ? t('seatDescription.table', { table: obj.table }) : null;
  const row = obj.row ? t('seatDescription.row', { row: obj.row }) : null;
  const seat = obj.seat ? t('seatDescription.seat', { seat: obj.seat }) : null;

  const parts = [];

  if (section) parts.push(section);
  if (row) parts.push(row);

  if (!section && !row && !table && seat) return seat;

  if (obj.type === 'Seat' && obj.table && obj.seat) {
    return (
      t('seatDescription.table', { table: obj.table }) +
      ', ' +
      t('seatDescription.seat', { seat: obj.seat })
    );
  }

  if (obj.type === 'Table' && obj.table && !obj.seat) {
    let result =
      `${section ? section + ', ' : ''}` + t('seatDescription.table', { table: obj.table });

    if (obj.paxs) {
      result += ' - ' + t('person', { count: obj.paxs });
    }

    return result;
  }

  if (section && row && seat) {
    return `${section}, ${row}, ${seat}`;
  }

  if (table && !section && !row) parts.push(table);

  if (seat && (section || row || table)) parts.push(seat);

  return parts.join(', ');
};
